module.exports = __webpack_public_path__ + "static/media/website.7ad58254.svg";